<template>
  <div style="background-color: #fff;padding: 10px;">
    <div class="comparisonTitle">
      <p>产品对比</p>
      <p>·导入负责工厂中的产品数据；</p>
      <p>·选择需要对比的产品；</p>
      <p>·从成本、配方维度进行相同产品不同版本、不同产品同一版本、不同产品不同版本跨工厂等场景进行对比；</p>
    </div>
    <a-space style="margin-bottom: 10px;">
      <a-button type="primary" @click="openProductModal">导入产品</a-button>
      <a-button @click="deleteProductRow" :disabled="selectedRowKeys.length === 0">移出产品</a-button>
      <a-button @click="openComparison" :disabled="selectedRowKeys.length < 2">产品对比</a-button>
    </a-space>
    <a-table 
      bordered
      row-key="id"
      :pagination="false"
      :row-selection="rowSelection"
      :scroll="{x: 1000}"
      :dataSource="list"
      :columns="columns" >
      <template slot="isActivate" slot-scope="text">
        {{text ? '是' : '否'}}
      </template>
      <template slot="isPushEbs" slot-scope="text">
        {{text == 1 ? '是' : '否'}}
      </template>
    </a-table>
    <product-list-modal :visible="productListVisible" @close="closeProductModal" :allIds="allIds" :allList="list" />
    <ProductComparisonDrawer :visible="productComparisonVisible" @close="closeComparison" :productIdList="selectedRowKeys" />
  </div>
</template>

<script>
import ProductListModal from './modal/ProductListModal.vue'
import ProductComparisonDrawer from './modal/ProductComparisonDrawer.vue'
import {productMixins} from './unitls'
export default {
  components: {ProductListModal,ProductComparisonDrawer},
  mixins: [productMixins],
  data() {
    return {
      selectedRowKeys: [],
      selectedRows: [],
      maxLen: 50,
      list: [],
      columns: [
        {
          dataIndex:'factoryName',
          title:"工厂名称",
          sorter: (a, b) => a.factoryName.localeCompare(b.factoryName,'zh'),
          width: 120,
        },
        {
          dataIndex:'productName',
          title:"产品名称",
          sorter: (a, b) => a.productName.localeCompare(b.productName,'zh'),
          width: 120,
        },
        {
          dataIndex:'formulaCode',
          title:"配方代码",
          sorter: (a, b) => a.formulaCode.localeCompare(b.formulaCode,'zh'),
          width: 120,
        },
        {
          dataIndex:'animalTypeName',
          title:"动物类型",
          sorter: (a, b) => a.animalTypeName.localeCompare(b.animalTypeName,'zh'),
          width: 100,
        },
        {
          dataIndex:'version',
          title:"版本",
          sorter: (a, b) => a.version-b.version,
          width: 80,
        },
        {
          dataIndex:'isActivate',
          title:"是否激活",
          scopedSlots: {customRender: 'isActivate'},
          sorter: (a, b) => a.isActivate-b.isActivate,
          width: 90,
        },
        {
          dataIndex:'isPushEbs',
          title:"是否推送",
          scopedSlots: {customRender: 'isPushEbs'},
          sorter: (a, b) => a.isPushEbs-b.isPushEbs,
          width: 90,
        },
        {
          dataIndex:'pushTime',
          title:"推送时间",
          sorter: (a, b) => new Date(a.pushTime).getTime() - new Date(b.pushTime).getTime(),
          width: 150
        },
        {
          dataIndex:'createTime',
          title:"创建时间",
          sorter: (a, b) => new Date(a.createTime).getTime() - new Date(b.createTime).getTime(),
          width: 150
        },
      ],
      productListVisible: false,
      productComparisonVisible: false,
    }
  },
  computed:{
    allIds(){
      let lst = []
      this.list.forEach(el => {
        lst.push(el.id)
      })
      return lst
    },
    rowSelection() {
      return {
        selectedRowKeys:this.selectedRowKeys,
        onChange: (selectedRowKeys,selectedRows) => {
          selectedRowKeys = selectedRowKeys.splice(0,this.maxLen);
          this.selectedRowKeys = selectedRowKeys
          let arr = [...this.selectedRows, ...selectedRows]
          this.selectedRows = selectedRowKeys.map(i => {
            return arr.filter(item=>item.id === i)[0]
          })
          this.list = [...this.list]
        },
        getCheckboxProps: record => ({
          props: {
            disabled: !this.selectedRowKeys.includes(record.id) && this.selectedRowKeys.length >= this.maxLen
          },
        }),
      }
    },
  },
  mounted(){
    console.log('selectedProduct',this.selectedProduct)
    if(this.selectedProduct.length){
      this.list = this.selectedProduct
    }
  },
  methods: {
    openProductModal(){
      console.log('allid',this.allIds)
      this.productListVisible = true
    },
    closeProductModal(list){
      if(list) this.list = list
      this.productListVisible = false
    },
    deleteProductRow(){
      this.$confirm({
        title: '删除',
        content: <p>确定将选中的产品移出对比吗？</p>,
        cancelText:'取消',
        okText:'确定',
        onOk: async () => {
          this.list = this.list.filter(el => !this.selectedRowKeys.includes(el.id))
          this.selectedRowKeys = []
          this.selectedRows = []
        },
      })
    },
    openComparison(){
      this.productComparisonVisible = true
    },
    closeComparison(){
      this.productComparisonVisible = false
    },
  }
}

</script>

<style lang="scss">
  .comparisonTitle{
    background-color: #F2F2F2;
    padding: 10px 20px;
    margin-bottom: 10px;
    p{
      margin-bottom: 0px;
    }
  }
</style>